import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { SectionIds } from '@shared/models';

import { ExpertiseExchangeComponent } from './expertise-exchange/expertise-exchange.component';
import { FastPerformanceSchemaComponent } from './fast-performance-schema/fast-performance-schema.component';
import { GiftShopSchemaComponent } from './gift-shop-schema/gift-shop-schema.component';
import { HandyToolsSchemaComponent } from './handy-tools-schema/handy-tools-schema.component';
import { LegalSupportSchemaComponent } from './legal-support-schema/legal-support-schema.component';
import { NativeSpeakingSupportSchemaComponent } from './native-speaking-support-schema/native-speaking-support-schema.component';
import { SeoOptimizationSchemaComponent } from './seo-optimization-schema/seo-optimization-schema.component';
import { StatisticsDetailingSchemaComponent } from './statistics-detailing-schema/statistics-detailing-schema.component';

@Component({
  selector: 'rp-home-schemas',
  standalone: true,
  templateUrl: './schemas.component.html',
  styleUrl: './schemas.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ExpertiseExchangeComponent,
    FastPerformanceSchemaComponent,
    GiftShopSchemaComponent,
    HandyToolsSchemaComponent,
    LegalSupportSchemaComponent,
    NativeSpeakingSupportSchemaComponent,
    SeoOptimizationSchemaComponent,
    StatisticsDetailingSchemaComponent,
    TranslateModule,
  ],
})
export class SchemasComponent {
  readonly firstSchemaId: SectionIds = SectionIds.FirstSchemas;
}
